<template><section><h1>Switch</h1>
<blockquote>
<p>开关</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>Size</td>
<td style="text-align:left">尺寸，可选值 <code>lg</code>/<code>md</code>/<code>sm</code></td>
<td><code>String</code></td>
<td><code>md</code></td>
</tr>
<tr>
<td>value</td>
<td style="text-align:left">绑定值，请使用<code>v-model</code>获取及设置</td>
<td><code>Boolean</code></td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td style="text-align:left">是否禁用</td>
<td><code>Boolean</code></td>
<td><code>false</code></td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Switch.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-2.vue?79a64b48